module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "ch-num"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("Chapter One")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('h2', {
    staticClass: "ch-title"
  }, [_vm._v("Overview of the South-West Pacific Area in 1942 and the Strategic Importance of Papua")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("A")]), _vm._v("fter the carrier attack by the Imperial Japanese Navy (IJN) on Pearl Harbor, Hawaii, on 7 December 1941, both the IJN and Imperial Japanese Army (IJA) conducted offensive operations across Asia and the Pacific spanning 7,000 miles from Singapore to Midway Island ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("see")])]), _c('a', {
    attrs: {
      "href": "#/xhtml/06_Chapter01#map1"
    }
  }, [_vm._v("Map 1")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/xhtml/#page_8"
    }
  }, [_vm._v("p. 8")]), _vm._v("). The success of Admiral Chuichi Nagumo’s aerial assault on the anchorage of the United States Navy’s (USN) Pacific Fleet and army installations that morning assured a transient naval supremacy for the IJN in the Pacific Ocean. Malaya and Singapore were early targets in the IJA’s major southern thrust along with additional supporting operations to seize the Philippine Archipelago, the Netherlands East Indies (NEI), Hong Kong and parts of British Borneo. Guam was occupied easily by 8 December and Wake Island fell on 23 December.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Further reinforcing Imperial Japan’s hegemony over the Pacific Ocean was the sinking in the South China Sea of HMS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Prince of Wales")]), _vm._v(" and HMS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Repulse")]), _vm._v(" on 10 December by land-based Mitsubishi G4M "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Betty")]), _vm._v(" and Mitsubishi G3M "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nell")]), _vm._v(" medium horizontal and torpedo-bearing bombers. These Royal Navy (RN) capital ships were dispatched by British Prime Minister Winston Churchill as a deterrent to Japanese expansion. Malaya and Singapore fell to Lieutenant-General Tomoyuki Yamashita’s numerically inferior Japanese 25th Army on 15 February 1942. This cataclysmic event occurred after only seventy days of resistance by Lieutenant-General Arthur Percival’s British and Commonwealth forces to the IJA juggernaut streaming though the jungles and roads of the Malay Peninsula and across the Straits of Johore to Singapore Island.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Prior to Malaya’s capture, the Japanese first aerially attacked Rabaul on northern New Britain Island on 21 January 1942, with over a hundred Japanese fighters and bombers attacking the main Australian air base in the Bismarck Archipelago to New Guinea’s north-east. On the night of 22–23 January, Major-General Tomitaro Horii’s 5,300-strong South Seas Detachment steamed into Rabaul’s Simpson Harbour. The Australian defenders withdrew after mounting some initial stout resistance to the amphibious invasion. As the Japanese overran northern New Britain in the ensuing days, most of the Australians were brutally massacred or died as prisoners. Rabaul would become the HQ for the Japanese Eighth Area Army with its five airfields and harbour, the latter transformed in the South Pacific’s main IJN fleet anchorage. All that remained to separate Australia’s Northern Territories across the Arafura Sea from the Japanese south-west Pacific offensive were a few Australian garrison troops and sappers at Port Moresby on Papua New Guinea’s southern coast.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0008-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "map1"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Map1. Strategic overview of the Pacic War, 1941–1942.")]), _vm._v(" After the IJN attack on Pearl Harbor, Malaya was invaded in December 1941 and was soon conquered by the IJA 25th Army. Singapore fell on 15 February 1942. The Philippine Islands were also invaded in December 1941. Filipino-American forces surrendered after their resistance on Luzon’s Bataan Peninsula in April 1942. Other American possessions, such as Guam in the Marianas and Wake Island, were captured in the Japanese juggernaut in December. The Dutch (Netherlands) East Indies also fell to Imperial Japanese forces in their drive towards the South-West Pacific and Indian Ocean. New Britain Island in the Bismarck Archipelago was invaded in January 1942 with the Australian forces there having retreated or being captured. Rabaul, at New Britain’s north-eastern tip, became the main bastion for the IJA and IJN in the south- western Pacific, with its superb Simpson Harbour and numerous airfields. Japanese outposts were established in North-West New Guinea and along the northern coast of Papua. Port Moresby on the southern Papuan coast and north-west Australia were now threatened. The massive extent of the Japanese conquest and ultimate ambitions of Imperial Japan at its high-water mark throughout the first half of 1942 was startling. In early June 1942, the US Navy won a decisive carrier-based aircraft victory over the IJN at the Battle of Midway, thereby eliminating a potential threat to the Hawaiian Islands. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Meridian Mapping")]), _vm._v(")")])])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("Since US Army and Navy planners believed that the Philippine Islands were not defensible if the Japanese mounted a full-scale attack, military preparations were wholly incomplete before General Douglas A. MacArthur’s arrival in 1935 to command the archipelago’s Filipino-American forces. Over the next six years, the build-up of forces under his leadership was both tardy and unfinished when the Japanese struck the Philippines. MacArthur’s air strength was destroyed mostly on the ground at Clark Field near Manila by Formosa-based Japanese bombers within hours of the attack on Pearl Harbor and its remnants quickly succumbed to the enemy’s air superiority. Although the Japanese expected a quick victory in the Philippines, largely due to their air and naval dominance, MacArthur’s Filipino-American troops retreated into the Bataan Peninsula and held out there until 9 April. It was not until 6 May that the neighbouring island fortress of Corregidor in Manila Bay capitulated following a Japanese invasion.")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("In early January 1942, Field Marshal Sir Archibald Wavell was appointed supreme commander of the cumbersome new combined American, British, Dutch and Australian Command (ABDACOM), headquartered on Java, after Churchill designated him C-in-C Far East on 30 December 1941. This command was ludicrous in its expansiveness as it encompassed all Allied forces in Burma, Singapore, Malaya, the Netherland East Indies (NEI), the Philippines (of which Wavell never assumed control) and North-West Australia. Fortunately, the onerous ABDACOM was disbanded on 22 February. However, by that time Hong Kong, Singapore, Malaya, the NEI, and Rabaul as well as many other Allied possessions were already lost.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Japanese High Command planned that once Malaya and Singapore were captured, resource-rich southern Sumatra and the NEI were to be seized. The vast natural resources there were needed to supply Japan’s decade-long war effort on the Asian mainland fighting the Chinese. Before Singapore’s surrender, Japanese units started the conquest of the NEI despite the fact that the local Dutch government had more than 100,000 men available. Unfortunately, this large force was spread out piecemeal across the major islands of the massive archipelago. The ABDACOM air force and naval detachment, the latter under American Admiral Thomas Hart, was defeated in the Battle of the Java Sea. Tarakan Island fell on 10 January, followed by the capture of Borneo and Sumatra. Java ended its resistance on 8 March. After the loss of the NEI, American General George Brett, who had been Wavell’s chief deputy in the ABDACOM, was appointed the commander of all US forces in Australia.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("Southern Burma was invaded in April 1942 with the intent, after defeating the British and Indian forces there, to sever the Burma Road to deprive Chiang Kai-shek and his army of the supply lifeline through the port of Rangoon. The IJA fielded only ")]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("eleven of its fifty-one divisions during these offensive operations in southern Asia, reserving the majority for home defence, the protracted offensives on the Chinese mainland, and to maintain a force in Manchuria to deter any possible Soviet move there. Still, Imperial Japan’s high-water mark had not yet been reached.")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("Japanese planners were confronted with a dilemma borne out of their string of rapid conquests, namely, should there be a further expansion south-eastward, seizing other Pacific island groups in order to cut the long supply lines from the United States to Australia and New Zealand, in effect isolating the Antipodes. Successive Japanese occupation of the Solomon Islands chain, the New Hebrides group, New Caledonia and the Fiji Islands would interdict sea-lane traffic from Pearl Harbor to Australia’s eastern coast cities of Brisbane, Sydney and Melbourne. Further seizure of the Tonga Islands, to the east of the Fiji Islands and south of Samoa would, in effect, interfere with Allied shipping from the American West Coast and through the Panama Canal to New Zealand. However, the IJA decided to move southward from the NEI in mid- January 1942, first to New Britain with Rabaul’s seizure and from there to occupy key positions in North-East New Guinea. By so doing, the Japanese High Command left the South Pacific supply routes open to Australia by postponing the establishment of further bases in the south-eastern Pacific. Thus, Australia and New Zealand were not isolated from Allied convoys and would become Australian-American staging areas for a counter-offensive. This Japanese strategic omission was later rectified with seizure and occupation of Bougainville, the New Georgia group of islands, as well as Guadalcanal and Tulagi along the Solomon Islands chain ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("see")])]), _c('a', {
    attrs: {
      "href": "#/xhtml/06_Chapter01#map2"
    }
  }, [_vm._v("Map 2")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/xhtml/#page_11"
    }
  }, [_vm._v("p. 11")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Darwin, a port and administrative seat in Australia’s North-West Territories, was now under direct threat after Japanese established bases along the northern coast of North-East New Guinea and, soon, Papua. The Australian Government, with most of its army in the Middle East, could only spare modest reinforcements for Darwin’s garrison, which was initially bombed by the Japanese on 19 February, just four days after Singapore’s surrender with a large contingent of AIF troops, which figured largely in Australia’s pre-war defence planning. In early March, Port Moresby had only the 30th Infantry Brigade, a field artillery regiment and coastal AAA units, totalling between 6,000–7,000 men. On 21 February, President Franklin Roosevelt ordered MacArthur to prepare to leave Corregidor for the southern Philippine island of Mindanao and then proceed to Australia. On 11 March, MacArthur and his retinue left Corregidor in four patrol torpedo (PT) boats and arrived at Mindanao. Battle-worn B-17 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Flying Fortresses")]), _vm._v(" transported MacArthur’s entourage to Batchelor Field, south of Darwin, on 17 March.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Australian Prime Minister John Curtain wanted his AIF divisions returned from the Middle East for home defence. Two brigades of the AIF 6th Division were transferred to Ceylon while the division’s remaining brigade and the AIF 7th Division was returned to Australia, the leading elements arriving in mid-March. With the AIF 9th Division remaining in the Middle East, Curtin was mollified by the ‘green’ US 32nd and 41st Infantry Divisions, both National Guard units, being hastily deployed to Australia’s defence in April and May 1942.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0011-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "map2"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Map2. The Solomon Islands and Bismarck Archipelago in the South and south-western Pacic theatres of operation, 1942–1943.")]), _vm._v(" In order to gain control over the sea-lanes in the south-eastern Pacific area so that the Antipodes could be isolated, the IJN occupied the islet of Tulagi off Florida Island in the southern Solomon Islands chain in early May 1942 and established a sea-plane base there. Soon thereafter, Japanese engineers and labourers began construction of an airfield along Lunga Plain on the larger island of Guadalcanal, to be renamed by the USMC as Henderson Field. The Japanese expanded their presence from North-East New Guinea’s Huon Peninsula’s locales of Lae and Finschhafen by establishing bases along Papua’s northern coast, notably at Buna during the late spring of 1942. With the exceptions of Japan’s lost or stalemated battles at the Coral Sea (May 1942), Midway (June 1942), Milne Bay (August-September 1942), the over-land Buna-to-Port Moresby assault along the Kokoda Trail (July-September 1942), and the failure to quickly defeat an isolated US 1st Marine Division (Reinforced) after the Allied naval presence in Guadalcanal’s offshore waters was reeling (August 1942), almost all of Imperial Japan’s initial strategic goals were achieved. On closer inspection, the dual set of Japanese campaigns in Papua and on Guadalcanal across the Solomon Sea were to detract strength from one another posing both tactical and strategic dilemmas, which Imperial Japan never overcame. On the other hand, the Allies designated the Papua and North-East New Guinea campaigns to be under General Douglas MacArthur’s SWPA theatre. The series of USMC and US Army amphibious assaults in the New Georgia Island group (July 1943) and at Bougainville (November 1943) up the Solomon Island chain after the victory on Guadalcanal in the South Pacific theatre was led by Vice-Admiral William Halsey. In effect, both of these Allied campaigns created a double envelopment of Rabaul. However, Rabaul was not to be directly invaded but rather neutralised after Japan’s loss of air superiority enabled Operation "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Cartwheel")]), _vm._v("’s, ever-increasing number of Allied land and carrier-based air attacks to isolate the enemy’s New Britain bastion. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Meridian Mapping")]), _vm._v(")")])])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("Japanese staging moves to take New Guinea began on 8–11 March, when IJA and IJN elements landed at Salamaua, Lae and Finschhafen on the Huon Peninsula in North-East New Guinea ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("see")])]), _c('a', {
    attrs: {
      "href": "#/xhtml/06_Chapter01#map3"
    }
  }, [_vm._v("Map 3")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/xhtml/#page_14"
    }
  }, [_vm._v("p. 13")]), _vm._v("). By April 1942, Allied air attacks were causing extensive damage to Japanese air capacity and naval movements in the Solomon Sea, so between 1–20 April, Special Naval Landing Force (SNLF) troops were also landed at multiple sites along the northern coast of both North-East and Netherlands New Guinea to assist in airfield construction. Strategically, the Pacific War was to be determined by either capturing enemy airfields or nearby suitable terrain to construct new ones to control the sea-lanes as well as to support future amphibious landings for expansion.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Japanese planned to isolate Australia’s Northern Territories, along with Darwin and its harbour, by occupying Port Moresby on the southern coast of Papua. Initially, rather than taking Port Moresby by an over-land route, the IJN was to capture it in an amphibious operation, which was mitigated by a US carrier task force at the Battle of the Coral Sea on 4–8 May. Despite the tactical loss of USS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lexington")]), _vm._v(" and damage to USS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Yorktown")]), _vm._v(", the Japanese invasion force strategically retreated after losing a carrier and having another damaged. Additionally, many experienced IJN pilots died in the sea battle, the first fought solely by carrier-based planes. This naval battle was Japan’s first major setback and nullified this initial Port Moresby amphibious invasion.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0013-01.jpg"
    }
  })]), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "map3"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Map3. The Papuan Campaign, July 1942–January 1943.")]), _vm._v(" Papua, comprising the south- eastern third of the entire island of New Guinea, is dominated by the Owen Stanley Range. Milne Bay, at Papua’s eastern tip, was the site of the first major Australian victory, which repelled a Japanese amphibious invasion in late August-early September 1942. The darkened dashed line punctuated by Papuan villages denotes the Kokoda Trail, which was the principal route from Buna to Port Moresby. From late July until mid-September 1942, the IJA South Seas Detachment steadily pushed the Australians south along the Kokoda Trail; seizing the track’s locales at Wairopi, Kokoda and Isurava until the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nankai Shitai")]), _vm._v("’s exhausting advance was halted by Tokyo at Ioribaiwa Ridge, 27 air miles from Port Moresby. Then, the Australians began their second advance north along the Kokoda Trail from Imita Ridge to reclaim an abandoned Kokoda Village and airfield in early November. The Australians pursued the retreating Japanese across the swollen Kumusi River in their drive onto the enemy’s northern coastal bastions of Gona and Sanananda. Contemporaneous with the Australian movement, MacArthur ordered the 2nd Battalion, 126th IR, to advance along a parallel track over the Owen Stanley Range from Kapa Kapa to Jaure. This hellacious march depleted the American ranks, prompting Major-General Harding’s desire to avoid future costly jungle and mountain marches. Henceforth, the US 32nd Division infantry battalions were air-transported by Lieutenant-General Kenney’s C-47s over the Owen Stanley Range to a new airfield cut from tall kunai grass at Wanigela near Collingwood Bay. Other airfields at Pongani near Oro Bay and Dobodura ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("see")])]), _c('a', {
    attrs: {
      "href": "#/xhtml/06_Chapter01#map4"
    }
  }, [_vm._v("Map 4")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/xhtml/#page_21"
    }
  }, [_vm._v("p. 21")]), _vm._v(") were also built to shorten the distance for the US 32nd Division’s assault on the Japanese fortified positions at Buna that commenced in November 1942. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Meridian Mapping")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("Coincidentally, on 4 May, the Japanese 3rd Kure SNLF, with the assistance of some IJN surface ships, secured the small islands of Tulagi and Gavutu, both being British colonial possessions, across from the larger Guadalcanal in the southern Solomon Islands. On 5 May, US Navy (USN) dive-bombers and torpedo planes from USS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Enterprise")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Yorktown")]), _vm._v(" raided Tulagi and sunk the Japanese destroyer "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kikutsuki")]), _vm._v(", which participated in Tulagi’s seizure, and damaged other IJN vessels. However, the Japanese 25th Air Flotilla established a sea-plane base on Tulagi so that the newly established enemy air presence could interdict Allied shipping in the region despite the Japanese naval commander at Rabaul’s concern that his lines of communication (LOC) stretching from Lae in North-East New Guinea to Tulagi in the Solomon chain were precarious after the Coral Sea battle.")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("New Guinea possessed no cities or towns, with the exception of the smaller ones at Port Moresby, Milne Bay, Lae and Finschhafen. In the almost 400 years of Portuguese, Dutch, British, German and Australian colonial involvement on New Guinea, all that existed were a few coconut plantations, trading posts and small Christian missions, such as at the villages of Buna and Gona on Papua’s northern coast. Port Moresby, on Papua’s south coast, had a population of 3,000 before the war, comprised mostly of native Papuans. Emanating from Port Moresby, only native paths connected the northern and southern Papuan coasts, the most famous being the Kokoda Trail (or Track to the Australians), named after the village situated in a narrow mountain valley 1,200 feet above sea level in the northern foothills of the Owen Stanley Range. Kokoda also had a small airfield, which was a main Japanese objective as they planned a future over-land advance from new beachhead garrisons established at Buna and Gona. Both combatant sides were busy evaluating either extant airfields or suitable Papuan terrain to construct new ones.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("During the late spring of 1942, the Japanese finally decided to marshal forces for its delayed south-eastern thrust to seize New Caledonia, Fiji and the Samoan Islands to sever sea-lanes and communication with Australia and New Zealand. On 11 June, as a result of the second major carrier engagement of the Pacific War at Midway (4–7 June), resulting in the loss of four Japanese large carriers and a major component of their naval air arm, the south-eastern Pacific island invasions were cancelled.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("The Japanese faced another strategic dilemma after losing two naval battles in consecutive months. Since they were committed to new landings along Papua New Guinea’s northern coast for an over-land attempt to seize Port Moresby, Lieutenant- General Harukichi Hyakutake’s 17th Army (headquartered at Rabaul) gathered its divisions from Davao (in the Philippines), Java and Rabaul to prepare for a summer Papuan offensive. Japanese General Headquarters agreed to a two-pronged approach on Port Moresby – one route would be along the coast from Papua’s easternmost Milne Bay which would be taken by an assault from the sea, while the other route would be over-land from Buna and Gona along the rugged Kokoda Trail. ")]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("By the end of July 1942, Lieutenant-General Hyakutake had landed 13,500 troops at Buna and Gona and had forced the Australians, mainly militia, back south beyond Kokoda. The fighting was mostly guerrilla-style with firefights and ambushes in both wet jungle and tall kunai grasslands. To the chagrin of Japanese planners, there was no possibility of taking any vehicle along the track since it was only a few feet wide and could only be traversed, through its ridges, valleys, jungles and streams by foot- slogging marches through calf-high thick mud.")])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Both the Allies and the Japanese were not prepared for a major war in the South Pacific. This corner of the globe was not only logistically remote but disease-ridden and ubiquitously wet. The Australians, many of whom had experience in the North African desert, Greece, Crete and Syria, had not had any training for the upland jungle they found in several parts of Papua. However, in Malaya’s jungles, IJA troops demon- strated an uncanny ability to leave main tracks and outflank their enemies. Likewise, the Japanese infantrymen in New Guinea, using camouflage and stealth, furthered their reputation of becoming masters at their relatively new practice of jungle warfare. In New Guinea, the Japanese, after circumventing Australian positions, would emerge from the jungle and unleash devastating fire from machine-guns, mortars, grenades and lower calibre portable artillery pieces on their opponents’ rear positions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When the American JCS gave MacArthur command of the SWPA (headquartered in Australia), he was assigned without a specific target date to re-capture Lae and Salamaua as well as to ‘seize and occupy Rabaul and adjacent positions in the New Guinea-New Ireland area’. MacArthur’s staff knew that, in order to re-take Lae and Salamaua, he needed an airfield on Papua’s northern coast and the logical place was Buna Mission, previously an Australian outpost 5 feet above sea level, with its small airfield, the Old Strip. Buna Village, a half mile to the north-west, was simply a collection of native huts. Ten miles to the north of Buna was an older Anglican mission at Gona, with locales such as Giruwa and Sanananda in between.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("Before the Japanese arrival, Buna was coveted as a future base and airfield complex by both the Japan and SWPA HQ. Soon after MacArthur’s engineers scouted Buna and concluded that the coastal terrain was adequate for an airfield, they departed. However, MacArthur directed the Australian commander in Port Moresby to secure Buna to prevent its use as an enemy outpost for an over-land trek to seize Papua’s southern coast as a springboard to invade northern Australia. Buna was ‘the northern terminus of the one good track to Port Moresby’, the Kokoda Trail ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("see")])]), _c('a', {
    attrs: {
      "href": "#/xhtml/06_Chapter01#map3"
    }
  }, [_vm._v("Map 3")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/xhtml/#page_13"
    }
  }, [_vm._v("p. 13")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In June, the Australians organised the 39th Battalion, a militia unit, along with a native constabulary unit to move towards Buna. On 7 July, elements of the Australian 39th Battalion were 30 miles north of Port Moresby, ready to start their ascent of the Kokoda Trail. Eight days later, Company B of the Australian 39th Battalion was at the outskirts of Kokoda Village. On 24 July, the remainder of the Battalion was ordered to get to Kokoda Village as quickly as possible from Port Moresby.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("On 15 July, MacArthur gave his orders for the establishment of his forward base at Buna, which was to commence two weeks later. Also, a new airfield was to be constructed at Dobodura, 15 miles to the south of Buna. There, a grassy plain had been identified that would be large enough for both bombers and fighters, since Allied reconnaissance flights had shown the Buna strip to be inadequate for the airbase that the SWPA commander was envisioning for the re-capture of Lae and Salamaua on North-East New Guinea’s Huon Peninsula.")])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The Japanese beat the Allies ‘to the punch’ at both Buna and nearby Gona. On 21–22 July, Japanese cruisers, destroyers and transports landed a preliminary force, under IJA Colonel Yosuke Yokoyama. This Yokoyama Advance Force comprised 4,400 engineers and soldiers from the 15th Independent Engineer Regiment, which was detailed to build depots and clear roads, and the 1st Battalion, 144th Infantry Regiment, as its main combat arm. Additionally, the IJA South Seas Detachment ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nankai Shitai")]), _vm._v(") HQ landed. The entire Japanese presence was under the overall command of Major-General Tomitaro Horii, the South Seas Detachment leader. The east-to-west running Buna-Giruwa-Sanananda-Gona coastal area was to be transformed into a base of operations as well as a series of fortified garrisons.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Soon after the Japanese landings at Buna, Colonel Yokoyama lost no time in sending his forward elements on to the start of their southerly march to Kokoda Village. The Yokoyama Advance Force started its first major assault to seize Kokoda Village with its prize airfield there against the forward echelon of the Australian 39th Battalion on 28 July, although this Japanese unit was initially tasked only with an engineering assessment of the condition and quality of the roads and need for repairing the Buna-to-Kokoda portion. However, Imperial Japanese HQ ordered the Yokoyama Advance Force to instead mount an over-land attack, without a prior thorough feasibility study, to seize Port Moresby, under the supervision of the IJA 17th Army commander, Lieutenant-General Hyakutake, headquartered at Rabaul. Hyakutake was to gradually augment the Yokoyama Advance Force over the ensuing days to 11,100 men, with the addition of the 41st Infantry Regiment (under Colonel Yazawa Kiyomi) and the remaining two battalions of the 144th Infantry Regiment (battle- hardened veterans of campaigns in China, the Philippines and Malaya), and a mountain artillery battalion by 13 August. These intended reinforcements were forced by Allied air interdiction to land at Basabua, to the west of Buna between Sanananda and Gona Mission. Then they were ferried east to Buna and dispatched for the trek to strengthen Yokoyama at Isurava to the south of Kokoda Village.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("A sceptical South Seas Detachment commander, Major-General Horii, doubted that a supply line of native porters (32,000 were deemed necessary) could maintain his LOC. In fact, the Kokoda Trail was a 145-mile mud path, not wider than 3–4 feet, that climbed mountains as high as 6,000 feet, which crossed some of the most inhospitable terrain in the world, comprising steep gorges, rapidly flowing streams and ")]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("always wet, moss-covered rocks and logs. This unforgiving locale was the hellacious site for the dire combat between the advancing Japanese and the retreating Australia militia battalions followed later by AIF brigades.")])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("With the Japanese advancing south along the Kokoda Trail from Buna in force, the Australian 39th Militia Battalion, tasked with blocking the enemy at Kokoda Village, was too few in number and too inexperienced in jungle combat to contain the enemy offensive. Despite a larger number of casualties, the Japanese inexorably pushed southward forcing the Australians back. By the end of July, after only seven days of fighting, Kokoda Village and its airfield were in Japanese hands and Japanese 17th Army HQ ordered Horii to further the offensive gains. Kokoda Village became a Japanese base for supplies and reinforcement as more troops were in transit from Rabaul for the attack across the Owen Stanley Range to Port Moresby.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Australian efforts to delay the Japanese were intensified when the 53rd Battalion of Australian militiamen moved up to assist the 39th Battalion, which was a spent force after three weeks of combat. By 16 August, the 21st Brigade of the veteran 7th AIF Division arrived on the Kokoda Trail and was led up the ‘Golden Stairs’ from Uberti. On 26 August, the Japanese re-invigorated their drive to take Port Moresby. The weight of the Japanese offensive continued and first the battle-weary militia and then the AIF 7th Division veterans fell back roughly 15 miles.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On 1 September, General Horii’s offensive received an additional 1,000 fresh reinforcements who had landed on the Papuan northern coast, which he intended to send to his 144th Infantry Regiment. Horii now had roughly a force of two complete infantry brigades along with service troops and engineers as well as two mountain gun batteries. As the Japanese engaged the seasoned AIF 21st Brigade veterans, the former’s casualties began to mount.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("In early September, Major-General Horii arrived at Kokoda Village with the two battalions of the 144th Regiment and Kiyomi’s 41st Regiment. However, Formosans and Korean labourers as well as Japanese soldiers had to carry supplies to the Advance Force’s front and bring the wounded back to Kokoda Village. Logistics was becoming a nightmare for Horii and he was behind schedule in his crossing of the Owen Stanley Range to attack Port Moresby. Also, malnutrition, infected leg sores and tropical diseases were culling the Japanese combat ranks. Yet the Australians were forced to retreat still and the Japanese were driven by their officers in customary infantry tactical doctrine to get ahead of them and to maintain pressure on their flanks. After this gruelling attempt, the Japanese positioned themselves along the ridge at Ioribaiwa and the Australian infantry dug in on the Imita Ridge, across the valley from the enemy, where each side stood firm ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("see")])]), _c('a', {
    attrs: {
      "href": "#/xhtml/06_Chapter01#map3"
    }
  }, [_vm._v("Map 3")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/xhtml/#page_13"
    }
  }, [_vm._v("p. 13")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Although Horii still had 5,000 troops attacking the Australians, the Japanese LOC had been steadily lengthening from both Buna and Gona, while the Australian LOC were becoming shorter as they retreated closer toward Port Moresby. The Imita "), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Ridge area was to be both the final Australian defensive point as well as the starting line for the Allied counter-offensive to re-take Kokoda Village and continue on to Buna and Gona. A fresh AIF 25th Brigade also arrived at the Imita Ridge area from Port Moresby.")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("It is ironic that a few days earlier, on 28 August, Hyakutake ordered Horii to advance to the southern side of the Owen Stanley Range and assume defensive positions on the Kokoda Trail, even though his force was gaining ground in their drive toward Port Moresby. Horii was to await the outcome of a second Japanese offensive, the IJN amphibious assault at Milne Bay. Earlier in July, Allied troops arrived at Milne Bay and occupied the northern and western shores of the bay’s coastline. There they established defensive positions and began hastily constructing airfields in early August to house a strong RAAF air presence. This Japanese amphibious offensive against Milne Bay was intended to seize the Allied airfields and establish a naval base for another attempted amphibious assault on Port Moresby, as well as support the concurrent Guadalcanal operation to the east across the Solomon Sea ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("see")])]), _c('a', {
    attrs: {
      "href": "#/xhtml/06_Chapter01#map2"
    }
  }, [_vm._v("Map 2")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/xhtml/#page_11"
    }
  }, [_vm._v("p. 11")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The IJN’s Eighth Fleet attack on Milne Bay was launched from Kavieng on New Ireland on 25 August. A 2,000-man Hayashi Force (1st Landing Force) attacked, but had lost a portion of its offensive strength when some of its assault elements were diverted for a mid-September 35th Infantry Brigade strike, under Major-General Kiyotake Kawaguchi, against Marine positions guarding Henderson Field on Guadal- canal. The Japanese at Milne Bay were under the faulty intelligence that there were only two or three companies of Australian infantry there. A second Japanese landing force with a naval labour corps arrived at Milne Bay on the morning of 26 August.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At Milne Bay, the Japanese owned the sea since the US and Royal Australian Navies were heavily engaged against the Japanese off Guadalcanal. However, ashore there were two Australian infantry brigades at Milne Bay. The whole of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Milne")]), _vm._v(" Force, as the collective brigades had been named, was commanded by Major-General Cyril Clowes and numbered about 4,500 infantry. Without naval forces, coastal guns or searchlights, Clowes awaited the Japanese landings after he had received reports of the sightings of transports moving along the eastern Papuan coast.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By 27 August, as more Japanese troops with light and medium tanks landed, the Australians withdrew along the northern shore’s track as they lacked effective infantry-controlled AT weaponry. Close Australian air support with P-40 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kittyhawks")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wirraways")]), _vm._v(" were effective against the enemy as they moved up to the Australian infantry positions. The Japanese used their patented tactics of encirclement and night assaults in an attempt to confuse and divide the Australians. Fighting raged for more than another week. Clowes was anticipating another Japanese landing on the night of 6 September since Japanese destroyers once again entered Milne Bay. However, their "), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("mission was to pick up the surviving infantrymen from their defeated amphibious assault and not to land reinforcements.")])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Without a concurrent amphibious assault on Port Moresby from Milne Bay, Major- General Horii was isolated and lacked sufficient air cover. As September progressed, Horii’s South Sea Detachment became severely malnourished and ravaged by disease such as malaria, dysentery, dengue fever and beriberi. On 16 September, the Japanese on Ioribaiwa Ridge literally wept for joy as they could now see the plains and sea around Port Moresby as well as searchlights at night at the Allied airfield there, 27 air miles away. This was as near to Port Moresby that the Japanese were to get. The Japanese supply system was stretched to its limits and the offensive had resulted in a majority of the force killed, wounded and disabled. Only one-quarter of the Japanese force that had left Buna in late July-early August was fit to fight after just a several- week interval of strenuous marching and jungle combat over the Owen Stanley Range. A stiffened Australian resistance at Imita Ridge, possessing shorter LOC to Port Moresby and a near-constant Allied air presence to attack Japanese supply lines running back to Buna, compelled Major-General Horii to halt his offensive to Port Moresby at Ioribaiwa Ridge and prepare defensive works")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On 24 September, as the defeat at Milne Bay and setbacks on Guadalcanal registered in the minds of the Imperial General Headquarters, Horii was ordered to withdraw along the Kokoda Trail and establish northern Papuan coastal defensive positions at Buna, Giruwa, Sanananda and Gona. Horii was planning to leave strong rear-guard positions as his Japanese troops positioned guns and dug weapon pits and trenches along the Ioribaiwa Ridge during the last week of September. His force was ordered to hastily withdraw from these field positions on 28 September. During their pull-back, the Japanese came under frontal and flank attack by the advancing Australian infantry. This was a strategic retreat for the Japanese, because of the continued need to augment infantry reinforcements into the cauldron on Guadalcanal to overcome the tenacious American 1st Marine Division (Reinforced) defence of the Henderson Field perimeter along the plain at Lunga Point.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("It was initially the Japanese who planned to build an airfield for land-based planes at Lunga Point on Guadalcanal across from Tulagi off of Florida Island. American scouting aircraft discovered construction of the Japanese airfield (soon to be re-christened Henderson Field) on Guadalcanal’s northern coast on 4 July ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("see")])]), _c('a', {
    attrs: {
      "href": "#/xhtml/06_Chapter01#map2"
    }
  }, [_vm._v("Map 2")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/xhtml/#page_11"
    }
  }, [_vm._v("p. 11")]), _vm._v("). Air- fields in both Papua and on Guadalcanal were a part of the larger Japanese strategy. Japanese documents captured later revealed the object of capturing Tulagi in May and building an airfield on Guadalcanal in July was to protect their flank while carrying out attacks on Port Moresby, both over-land across the Owen Stanley Range and via an amphibious assault on Milne Bay. By mid-July, construction was underway with anticipated completion by mid-August. When integrated with a Japanese presence in and around the Solomon Sea waters, along with the newly activated IJN Eighth Fleet "), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("(the Outer South Seas Force) under Vice Admiral Mikawa, Allied shipping in the South Pacific and on the sea-lanes to the Antipodes could be interdicted.")])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Although American aircraft bombed the rudimentary Japanese airfield on Guadal- canal to delay its completion, Admiral Ernest King, the Navy C-in-C, entertained a move into the Solomon Island chain beginning in March 1942. Admiral Chester W. Nimitz, C-in-C Pacific Fleet, advocated the taking of Tulagi by a Marine Raider Battalion after its seizure by the Japanese in early May. However, King vetoed the project. With time, though, the JCS returned to the idea that Tulagi should be assaulted to negate the IJN air presence there and establish an American base in the Solomons for future operations. The Japanese construction of an airfield on Guadalcanal sounded a louder clarion. Actual planning for a Guadalcanal invasion, code-named Operation "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Watchtower")]), _vm._v(", was being finalised from 26 June–2 July. The JCS ordered Nimitz and his Marines to amphibiously assault Tulagi and Guadalcanal, with Vice-Admiral Robert Ghormley as the local USN commander and the reinforced 1st Marine Division under the command of Major-General Alexander A. Vandegrift, to spearhead the assault on 7 August. The American invasion of Guadalcanal established a strategic dilemma for the Japanese as they were now fighting the Allies on two fronts separated by the expansive Solomon Sea. This quandary among the Japanese military leaders and planners was to last throughout 1942, as both the Guadalcanal and Papuan campaigns reached climactic proportions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By 12 October, the Australian 2/25th, 2/31st, and 2/33rd Battalions of the AIF’s 7th Division had moved up the Kokoda Trail to a position to attack the tenaciously retreating Japanese at Templeton’s Crossing along the Owen Stanley Range, which was re-taken on 17 October. Due to battle casualties, disease and exhaustion, these Australian battalions were relieved by Brigadier Lloyd’s 16th Brigade, which had been dispatched from Ceylon to combat the Japanese at Eora Creek.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("After the re-capture of Kokoda Village in early November, Allied planners prepared for their next offensive ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("see")])]), _c('a', {
    attrs: {
      "href": "#/xhtml/06_Chapter01#map4"
    }
  }, [_vm._v("Map 4")]), _vm._v("), which would become a three-month bloody onslaught from 16 November 1942 to 22 January 1943, to recover the vital bases and airfields of Buna, Gona, the enemy beachhead terminus of the Soputa- Sanananda track at Sanananda, and an IJA garrison outpost and hospital at Giruwa. Lieutenant-General Hatazo Adachi, now commanding the IJA 18th Army in New Guinea from November 1942 onwards, had several thousand troops available to him for the defence of his greater Buna-Gona-Sanananda-Giruwa beachhead line of fortified outposts that ultimately extended into North-East New Guinea.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0021-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "map4"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Map4. MacArthur’s counter-offensive against the Buna-Giruwa-Sanananda- Gona Front, November 1942.")]), _vm._v(" The Allied axes of advance against the Japanese coastal garrisons were determined largely by the swampy Papuan terrain and the dearth of usable trails from the inland areas to move north. The Japanese were situated along an 11-mile front of fortified positions stretching from Cape Endaiadere in the east and extending westward through the Duropa Plantation, Buna Mission, Buna, Giruwa, Sanananda and Gona. The Japanese anchorage was at Basabua between Cape Killerton and Gona. The US 32nd Division’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Warren")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Urbana")]), _vm._v(" forces advanced on Buna Mission from the east and against Buna to the west of the swamp, respectively. The Australian 7th Division advanced northwards along the Kokoda Trail from Wairopi. The 7th Division’s 25th Brigade vectored west through poorly documented, enemy-fortified terrain onto Gona. The Australian 16th Brigade was tasked with a northward movement up the Soputa-Sanananda Motor Track (MT) until it forked to heavily defended enemy positions towards Sanananda to the east and Cape Killerton to the west. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Meridian Mapping")]), _vm._v(")")])])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("MacArthur had to protect his newly acquired airfield at Kokoda as well as another set of airstrips at Dobodura, just north of the Samboga River ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("see")])]), _c('a', {
    attrs: {
      "href": "#/xhtml/06_Chapter01#map4"
    }
  }, [_vm._v("Map 4")]), _vm._v("). Continued Japanese possession of Buna ultimately threatened both landing field areas, so MacArthur was set on a campaign of annihilation against the entrenched enemy along Papua’s northern coast rather than settle for the less costly strategy of starving them into capitulation. The Japanese Imperial Headquarters, on the other hand, insisted that Buna be held at all costs and that the Dobodura airfield, 10 miles south of Buna, be destroyed. The loss of Dobodura would hamper Allied reinforcements and weaken their capacity for air attacks. Tokyo reasoned that losing Buna would put future operations on New Guinea, and the Japanese position on Rabaul, in serious jeopardy.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0022-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The IJN commanding officer of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Shokaku")]), _vm._v(", one of Admiral Nagumo’s six carriers that participated in the attack on Pearl Harbor on 7 December 1941, stands above the flight-deck as his aircraft commenced take-off to attack Oahu in the Hawaiian Islands. ("), _c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NARA")])]), _vm._v(")")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0023-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("US Navy seamen in a small craft search for survivors amid the smouldering, twisted wreckage of USS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("West Virginia")]), _vm._v(" at ‘Battleship Row’ at the US Pacific Fleet’s main anchorage at Pearl Harbor on Oahu on 7 December 1941. ("), _c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NARA")])]), _vm._v(")")])])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0023-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Two IJN air-crewmen load ordnance onto their twin-engined Mitsubishi G3M2 ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nell")]), _vm._v("), a medium horizontal and torpedo bomber, at an airfield in Indochina for the devastating aerial attack that sank both HMS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Prince of Wales")]), _vm._v(" and HMS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Repulse")]), _vm._v(" of the RN’s Force "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Z")]), _vm._v(" in the South China Sea off the Malayan coast on 10 December 1941. ("), _c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NARA")])]), _vm._v(")")])])]), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0024-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("IJA infantrymen in the Malayan capital of Kuala Lumpur between two of their Type 94 (1934) medium tanks, which were primarily designed for reconnaissance and screening. The Type 94 tank, which had a two-man crew, weighed 15 tons and mounted a 57mm turret gun and two 7.7mm MGs. Although obsolete by ETO standards, IJA armour faced no Allied tanks since none were shipped to Malaya. It was wrongly concluded by British commanders that the rugged jungle terrain and absence of suitable roads would preclude the use of armour on the Malay Peninsula. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Author’s collection")]), _vm._v(")")])])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0024-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("An Australian 2-pounder gun-crew fires the AT weapon on a Japanese light tank column at a pre-arranged ambush on the Muar-Bakri Road. Many Japanese light tanks were disabled in this engagement by the near obsolete Allied AT gun. ("), _c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NARA")])]), _vm._v(")")])])]), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0025-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("An Argyll and Sutherland Highlander infantryman jumps from his Lanchester armoured car in Malaya with a Vickers Mk I MMG that fired the same .303-inch calibre cartridge as the Bren LMG, as well as the standard SMLE rifle. The other Highlander to the right is getting the water can and ammunition box ready. As a result of its water-cooling, this MMG was exceptionally suited for continuous firing. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Library of Congress")]), _vm._v(")")])])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0026-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Lieutenant-General Arthur Percival and his staff march to the Ford Factory at Bukit Timah on Singapore accompanied by IJA Staff Officer Sugita. The British commander on Singapore was about to enter into surrender negotiations with the IJA 25th Army commander, Lieutenant-General Tomoyuki Yamashita, on 15 February 1942. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Author’s collection")]), _vm._v(")")])])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0026-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Japanese infantry, with their bayonets fixed to their "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Arisaka")]), _vm._v(" rifles, advance northwards from Rangoon to the outskirts of Mandalay at the end of April 1942. General Sir Harold Alexander had arrived in Burma in early March in an attempt to stem the inexorable Japanese advance, but he was unsuccessful at repeated battle locales. On 26 April, Alexander decided that his main objective was to withdraw as much of his Burma Army as possible to India for reorganisation and to defend the sub-continent from a feared Japanese invasion there. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Author’s collection")]), _vm._v(")")])])]), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0027-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("An IJA artillery platoon with rapid fire artillery pieces bombards Allied positions in Burma’s mountainous region in the spring of 1942. Terrain obstacles did not deter the Japanese rapid advance and enabled enemy infantrymen to get around the flanks of the Allied defenders. ("), _c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NARA")])]), _vm._v(")")])])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0028-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Indian troops in defensive positions on the Sittang River, awaiting the Japanese assault. On the night of 22/23 February 1942, a controversial order was given, based on a miscommunication, to blow up the bridge. The line of retreat of the British and Indian troops still on the eastern side of the river was thus severed. ("), _c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NARA")])]), _vm._v(")")])])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0029-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Lieutenant-General Joseph Stilwell leads the ‘Walkout’ from Burma in May 1942. After learning that the Japanese had outpaced his withdrawal towards Myitkyina, Stilwell and a party of 114 British, American and Burmese began their trek both over-land and by waterways. They crossed the Chindwin River in dug-outs and ferries at Homalin, hours before a Japanese cavalry detachment arrived there. Setting a demanding pace, Stilwell managed to extricate his entire party to safety in India’s Assam Province. ("), _c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NARA")])]), _vm._v(")")])])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0029-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("British troops of Lieutenant-General William Slim’s ‘BurCorps’ traverse one of the myriad Burmese waterways back to the Indian frontier during the retreat from Mandalay in May 1942. Although beaten upon reaching Assam, India, these soldiers still maintained their military presence and formation to become the nidus for Slim’s future 14th Army. ("), _c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NARA")])]), _vm._v(")")])])]), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0030-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A Japanese SNLF reconnaissance party observes an artillery bombardment of US and Filipino positions after General MacArthur’s troops withdrew into the Bataan Peninsula, where a tenacious defence was mounted until an April 1942 surrender. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("USAMHI")]), _vm._v(")")])])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0030-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Troops of the 61st Infantry Regiment shout their traditional "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("banzai")]), _vm._v(" salute to the emperor at Mount Limay on the Bataan Peninsula in April 1942. Major-General Edward P. King, Commanding General, Luzon Force, surrendered his Filipino-American forces on Bataan to the IJA 14th Army under the command of Lieutenant-General Masaharu Homma. ("), _c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NARA")])]), _vm._v(")")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0030-03.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Lieutenant-General Douglas A. MacArthur ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("right")]), _vm._v("), commander of US Army Forces in the Far East (USAFFE) stands with Major-General Jonathan Wainwright ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("left")]), _vm._v("), the commander of the North Luzon Force, I Philippine Corps, on 10 October 1941, before the Japanese invasion. Wainwright replaced MacArthur as USAFFE commander when the latter was ordered by President Roosevelt to leave Corregidor to become C-in-C, SWPA, with headquarters in Australia. ("), _c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NARA")])]), _vm._v(")")])])]), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0031-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("US Army Captain Arthur Wermuth holds his 0.45-inch calibre Thompson SMG beside a Filipino officer on the Bataan Peninsula during the late winter of 1942. Wermuth had reportedly killed more than 100 Japanese soldiers during Wainwright’s retreat into the defensive line there. ("), _c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NARA")])]), _vm._v(")")])])]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0031-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("American and Filipino troops cross a Luzon river via a duckboard bridge atop pontoons. The advancing IJA 14th Army troops, as in other conquest locales, had sufficient engineer troops to rapidly span the many rivers, which the American commanders erroneously believed would delay the enemy. ("), _c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NARA")])]), _vm._v(")")])])]), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0032-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("American prisoners with their hands up plod gloomily forward with their smiling Japanese conquerors beside them during the Bataan Death March in April 1942. After a full-scale invasion of Luzon by the Japanese within days of the Pearl Harbor attack, American and Filipino soldiers were forced to retreat into a slim defensive position on the island’s western Bataan Peninsula in January 1942. On 9 April, the American and Filipino forces formally surrendered to the Japanese. Immediately thereafter, the Japanese began to march the 12,000 American and 64,000 Filipino prisoners northward on a 60-mile journey into captivity, committing atrocities on the route. The ordeal lasted several days with thousands of Americans and Filipinos dying. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Library of Congress")]), _vm._v(")")])])]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0032-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Within the Malinta Tunnel on Corregidor Island in Manila Bay, a subdued General MacArthur sits with his COS, Brigadier- General Richard K. Sutherland. MacArthur’s subordinate commanders had a difficult time working with Sutherland, who was very protective of his commander’s time. This interruption in a fluid chain of command is believed to have contributed to the catastrophic destruction of much of MacArthur’s Far Eastern Air Force (FEAF) at Clark Field on 8 December 1941, during a massive aerial attack by IJN land-based G3M "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nell")]), _vm._v(" and G4M1 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Betty")]), _vm._v(" twin-engined bombers. Numerous US B-17 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Flying Fortress")]), _vm._v(" four- engined bombers and P-40 fighters were destroyed on the ground. ("), _c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NARA")])]), _vm._v(")")])])]), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0033-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The Japanese invading force captured thousands of American and Filipino soldiers on Corregidor. Here survivors of the intense Japanese bombardment and invasion of the island are ushered from out of the Malinta Tunnel, which was an underground warren of infirmaries, offices, machine shops and headquarters. The defenders in the tunnel were able to withstand the bombardment but not the assault of the Japanese ground forces. ("), _c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NARA")])]), _vm._v(")")])])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0034-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("At Rabaul on New Britain Island in the Bismarck Archipelago, Japanese SNLF troops move against Australian defensive installations. The Japanese invasion quickly overpowered the Australians, many of whom were massacred or taken prisoner. Rabaul, with its excellent anchorage at Simpson Harbour, would serve the IJN vessels while numerous airfields were completed for future offensive operations. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Author’s collection")]), _vm._v(")")])])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0034-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Australian troops clean up the wreckage in Darwin, Australia, after the first Japanese air-raid on 19 February 1942, which lasted thirty minutes. Darwin was the administrative seat in the North-West Territories and just across the Arafura Sea and Torres Strait from Papua New Guinea. At the request of the relatively new Australian prime minister, John Curtin, the North-West Territories of Australia, centred on Darwin, was incorporated into the ABDA command zone on 24 January. Darwin was also a key staging post in Allied supply routes to the East Indies. Due to a dockyard workers’ strike, Darwin’s harbour was crammed with ships carrying vital supplies for the Allied troops. The attack was mounted by 188 Japanese aircraft launched from four IJN carriers 200 miles away under the command of Vice Admiral Chuichi Nagumo, who led the Pearl Harbor raid. Eight ships were sunk, including USS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Peary")]), _vm._v(", and another thirteen were damaged. Around two hours later, fifty more planes from captured Dutch fields in the NEI destroyed Darwin’s airfield. Over the next twenty-one months, Darwin was bombed another sixty-two times. ("), _c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("USAMHI")])]), _vm._v(")")])])]), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0035-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("General Douglas MacArthur ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("centre")]), _vm._v("), AIF C-in-C General Thomas Blamey ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("left")]), _vm._v("), and the prime minister, John Curtin ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("right")]), _vm._v("), in Australia in late March 1942. It was Curtin who requested Roosevelt to assign MacArthur as commander of Allied Forces in the SWPA. With the best AIF troops in either the Middle East or captured at Singapore, Curtin knew that the United States would have to bear the brunt of Australia’s defence. In Melbourne, MacArthur and Curtin cemented a strong working and personal liking for each other. MacArthur told Curtin, ‘We two, you and I, will see this thing through together. We can do it and we will do it. You take care of the rear and I will handle the front.’ On 30 March, it was formally decided that MacArthur, from Australia, would command the offensives to recapture the islands north of Australia, the NEI and, ultimately, the Philippines. However, the re-occupation of Papua New Guinea and the maintenance of Port Moresby as a forward base of operations were paramount initial tasks. The next day, MacArthur was appointed C-in-C SWPA, effective 18 April. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("USAMHI")]), _vm._v(")")])])]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0036-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A B-25B medium "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mitchell")]), _vm._v(" bomber ready for take-off from the flight-deck of USS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hornet")]), _vm._v(" to commence Lieutenant-Colonel James H. Doolittle’s Tokyo Raid. US Navy Captain Marc A. Mitscher commanded the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hornet’s")]), _vm._v(" maiden voyage. Vice-Admiral Halsey commanded TF-16, comprising the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hornet")]), _vm._v(" and USS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Enterprise")]), _vm._v(" as well as escorting cruisers and destroyers. At 0820 hrs on 18 April 1942, amid rough seas, sixteen B-25Bs from the 17th Bombardment Group were launched earlier than planned after TF-16 was sighted by an enemy picket vessel. Admiral Isoroku Yamamoto, commander of the IJN’s Combined Fleet, and other IJN commanders were humiliated by the Doolittle Raid’s propaganda coup heralding a start of an American counter-offensive in the Pacific. The Tokyo Raid contributed to the Japanese military leaders’ support for a Midway Island invasion for June. ("), _c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NARA")])]), _vm._v(")")])])]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0037-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("IJN "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mitsubishi")]), _vm._v(" A6M2 Model 21 ‘Zeroes’ warming up on the flight-deck of the Japanese carrier "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Shōkaku")]), _vm._v(", just prior to the aerial conflict at the Battle of the Coral Sea on 8 May 1942. The superb Japanese fighters were fitted with an external fuel tank, which increased the range of these aircraft to provide aerial cover for the IJN bombers and torpedo aircraft. ("), _c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NARA")])]), _vm._v(")")])])]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0037-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Just prior to the carrier air conflict at the Battle of the Coral Sea on 8 May 1942, USS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lexington")]), _vm._v(" moves towards the combat area as seen from its sister carrier, USS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Yorktown")]), _vm._v(". This was to be the first naval conflict where carrier aircraft only and not surface ships were to duel with one another as the USN attempted to interdict the IJN amphibious assault on Port Moresby. ("), _c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NARA")])]), _vm._v(")")])])]), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0038-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("USS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lexington")]), _vm._v(", with a huge plume of smoke emerging from its flight-deck. The carrier’s company climb down ropes into the water for rescue by an awaiting destroyer. After the ship’s abandonment, another explosion wracked the ship. With everyone off the ship, USS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Phelps")]), _vm._v(", a destroyer, fired its torpedoes at the carrier dispatching it into 2,400 fathoms of water. Despite the loss of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lexington")]), _vm._v(" and the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Yorktown")]), _vm._v(" being damaged, this was the first time that the IJN retreated with the strategic outcome of the carrier naval battle being that Port Moresby would not be amphibiously assaulted and remain under Australian control. From a tactical standpoint, the American pilots sunk the carrier "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Shoho")]), _vm._v(" and had damaged another Japanese carrier, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Shōkaku")]), _vm._v(". Another salutary outcome of the naval battle for the Americans was that the Japanese carrier "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Zuikaku")]), _vm._v(" was mothballed upon return to Japan, not because she was damaged, but because she had lost so many of her trained pilots that she was not considered a good fighting vessel any longer. ("), _c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NARA")])]), _vm._v(")")])])]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0038-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Officers and petty officers of the 3rd "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kure")]), _vm._v(" SNLF, who seized Tulagi, Gavutu and Tanambogo on 3 May 1942. This picture was taken prior to the invasion at their base in Japan. Tulagi had been manned by only twenty-four Australians maintaining four Catalina patrol planes. Other Japanese forces that landed on Tulagi and the adjacent islets included 400 men of the Yokohama Air Group, a naval sea-plane base unit, a four-gun heavy anti- aircraft battery, a company of the 6th "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sasebo")]), _vm._v(" SNLF, and communications personnel necessary to install and operate a high-power radio station. This installation would be amplified by the arrival of twelve "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kawanishi")]), _vm._v(" flying-boats and twelve ‘Zero’ float fighters. The overwhelming majority of these Japanese forces were killed during harsh conflict for the islands on 7–9 August against the assaulting elements of the 1st Marine Division. ("), _c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NARA")])]), _vm._v(")")])])]), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0039-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The Japanese destroyer "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kikutsuki")]), _vm._v(", which participated in the Tulagi invasion of 3 May 1942. This IJN vessel provided naval gunfire support for the 3rd "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kure")]), _vm._v(" SNLF that made its landing unopposed. The tiny Australian garrison had rapidly evacuated the island after a heavy Japanese air-raid on 1 May. On 4 May, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kikutsuki")]), _vm._v(" was sunk by carrier aircraft from USS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Yorktown")]), _vm._v(", which was in local waters just prior to the Battle of the Coral Sea. ("), _c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NARA")])]), _vm._v(")")])])]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0040-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("District Officer Martin Clemens poses with his native scouts on Guadalcanal. Clemens, a Cambridge graduate and captain commissioned in the British Army, was situated at Aola, the local seat of government before the war, along the eastern portion of the northern coastal plane. On 28 May 1942, Clemens became aware of a Japanese landing party surveying Lunga Plain and forwarded the information to Australia. This was an inspection party of Captain Shigetoshi Miyazaki of the sea-plane-equipped Yokohama Air Group stationed at Tulagi that favourably reported Guadalcanal as a suitable installation for an advanced air base in the southern Solomon Islands. From June to July 1942, more than 2,500 men of the 11th and 13th Construction Units landed at Lunga Point to build the airfield on Lunga Plain, and they were duly observed by Clemens and his native scouts. ("), _c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NARA")])]), _vm._v(")")])])]), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0041-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Henderson Field seen from a low-flying airplane. The Japanese had nearly completed the airstrip with only the corner of the runway needing to be levelled and surfaced before the 1st Marine Division landed on 7 August 1942. Also, trees in the coconut plantation to the right had to be cut down to make room for the airfield. The linear markings off to the right of the airfield are where felled coconut trees were lying. The clump of trees in the background at the end of the runway was an obstacle. Right after the invasion, General Vandegrift correctly reasoned that completion of the airfield was the strategic key to the Marines’ survival. A 180ft unfinished gap in the centre of the field had to be completed in order to accept Marine and Navy aircraft. By 1 August, the runway was approximately 2,700 feet, and six days later its extent was a further 1,100 feet. The field’s width was only 150 feet. ("), _c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NARA")])]), _vm._v(")")])])]), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0041-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("With the bow ramps of LCVPs down, Marines from Companies B and D of the 1st Raider Battalion along with the 2nd Battalion, 5th Marines, landed between 0800 and 0915 hrs on Tulagi’s southern coast on 7 August 1942. Lieutenant-Colonel Merritt Edson’s Raiders swept eastwards, while elements of the 5th Marines moved westwards. It would not be until D-Day+2 that Tulagi would be secured after fanatical Japanese SNLF resistance. The Marines leaving the LCVP ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("foreground")]), _vm._v(") are pulling a small artillery piece across the bow ramp. ("), _c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NARA")])]), _vm._v(")")])])]), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0042-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("SNLF infantrymen captured on Tulagi are shown in captivity after the two-day battle for the island. Throughout the Pacific War, the tenacity of these troops that were deployed in amphibious assaults was a constant. ("), _c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NARA")])]), _vm._v(")")])])]), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0042-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The Marines’ ‘Cactus Air Force’ headquarters building at Henderson Field (also called the ‘Pagoda’) soon after the airstrip’s capture by elements of the 1st Marine Division during early August 1942. This building often served as the aiming site for Japanese aerial and naval bombardment during the height of the battle to neutralise Henderson Field as an ‘unsinkable aircraft carrier’. The Japanese expended increasing air, naval and ground forces to capture Henderson Field, all of which detracted supplies and reinforcements contemporaneously from the Imperial troops fighting amid the Owen Stanley Range and along the Kokoda Trail in Papua New Guinea in their trek towards capturing Port Moresby. ("), _c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NARA")])]), _vm._v(")")])])]), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0043-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A dual 20mm AA gun on a 40mm gun mount in its sandbagged pit along Henderson Field as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bell")]), _vm._v(" P-39 single-seat "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Airacobra")]), _vm._v(" fighter-bombers are seen ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("background")]), _vm._v("). This USAAF aircraft saw action on both Guadalcanal and Papua with its single 37mm fixed forward-firing cannon and two 0.5-inch calibre MGs in the nose, along with four 0.3-inch calibre MGs in the leading edges of the wings. AA defence along with Marines and later US Army infantrymen manning Henderson Field’s perimeter were paramount as the Japanese attempted to wrest the airstrip from American forces. The near-constant naval bombardment of Henderson Field from the waters of ‘Ironbottom’ Sound off Guadalcanal’s northern coast necessitated continuous repair of the airfield. At times, Henderson Field was not operational due to the ferocious Japanese bombardment. ("), _c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NARA")])]), _vm._v(")")])])]), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_43"
    }
  }), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0044-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The 1st Marine Division employed M3 light tanks of the 1st Tank Battalion on Guadalcanal. A column of these light tanks is shown here passing a disabled Japanese truck on the fringe of a coconut grove. After a disjointed nocturnal attack by a detachment of the IJA 28th IR, led by Colonel Kiyoano Ichiki, was repelled by Marines defending the mouth of ‘Alligator’ Creek (also called Tenaru River) on 20–21 August 1942, the Marine M3 light tanks attacked the remaining Japanese forces through the coconut grove. This was the first Japanese attempt to seize Henderson Field by ground attack. The M3 light tanks were vulnerable to Japanese AT defences due to their thin armour. ("), _c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NARA")])]), _vm._v(")")])])]), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_44"
    }
  }), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0045-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Dead Japanese soldiers of the 900-man force of the IJA 28th IR, led by Colonel Kiyoano Ichiki, lying in a sandpit after their failed attempt to outflank Marine positions defending the Henderson Field perimeter by moving through the surf across the mouth of ‘Alligator Creek’ on 20–21 August 1942. ("), _c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NARA")])]), _vm._v(")")])])]), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0045-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Major-General Kiyotake Kawaguchi with his 35th Infantry Brigade Staff in the Philippines. In earlier Japanese plans, the Brigade was to prepare for operations at Milne Bay and the Louisiade Archipelago at the far eastern end of New Guinea. But revised IJA 17th Army operations dispatched Kawaguchi’s Brigade to Guadalcanal to attempt Henderson Field’s seizure through a co-ordinated ground offensive. However, due to complicated jungle marches, not all of Kawaguchi’s battalions (totalling more than 3,000 men) arrived in unison for a concerted attack on Lieutenant-Colonel Merritt Edson’s dug-in Raider, Parachute, Pioneer, Engineer and 5th Marine battalions on 12–14 September 1942. Kawaguchi’s attack failed with the Americans successfully holding the higher ground above Henderson Field. This failed attack on ‘Edson’s’ Ridge occurred at the time IJA 17th Army, a corps-sized command, led by Lieutenant-General Harukichi Hyakutake at Rabaul, was directing the over-land combat offensive against Port Moresby in Papua New Guinea. Hyakutake was confronted with a dilemma. In order to dispatch sufficient troops to Guadalcanal to defeat the 1st Marine Division, he was unable to reinforce his drive onto Port Moresby. The defeat of Kawaguchi’s battalions contributed heavily to Hyakutake, days later, halting his offensive against Port Moresby at Ioribaiwa Ridge and ordering a retreat to defensive positions at Buna and Gona. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Author’s collection")]), _vm._v(")")])])]), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_45"
    }
  }), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0046-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A trio of artillerymen from the 11th Marines sighting-in their 75mm pack Howitzer which, along with 105mm Howitzers, provided devastating fire to break-up enemy concentrations forming for ground attacks against the Henderson Field perimeter. The 75mm pack Howitzer was small and easy to move ashore as well as break down into component parts for movement to other positions. ("), _c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NARA")])]), _vm._v(")")])])]), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0046-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A Marine scans the ‘Edson’s’ or ‘Bloody’ Ridge battlefield after almost all of the enemy corpses and weapons’ debris had been removed after the 12–14 September 1942. The maintenance of Henderson Field in American hands compelled the Japanese High Command to strategically shift the IJA 17th Army operations from Papua New Guinea to heavily reinforcing Guadalcanal with ground troops as well as aerial and naval bombardment. ("), _c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NARA")])]), _vm._v(")")])])]), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_46"
    }
  }), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0047-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("With the increasing IJA commitment of troops to Guadalcanal, the Americans on the island were reinforced with the 7th Marines on 18 September 1942. On 7–9 October, the Second Battle of the Matanikau River, well to the west of Henderson Field, occurred between a number of Marine formations and elements of the IJA 4th IR. Above, four haggard-appearing Marines carry one of their wounded on a litter along a coconut grove track near the river that bisected the battlefield to the east of Point Cruz. ("), _c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NARA")])]), _vm._v(")")])])]), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_47"
    }
  }), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0048-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A Marine inspects the wreckage of an IJA Type 97 medium tank that was destroyed at the mouth of the Matanikau River on 23 October 1942. Both the IJA and IJN leadership were committed to re-taking all of Guadalcanal and compelling Major-General Alexander A. Vandergrift to surrender his 1st Marine Division (Reinforced) along with elements of the US Army’s ‘Americal’ Division that joined the island combat. As Japanese reinforcements of troops, armour, planes and ships were added to the Guadalcanal cauldron, Japanese operations in Papua New Guinea were minimized to the defence of the northern coast’s garrisons at Buna, Gona and Sanananda. ("), _c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NARA")])]), _vm._v(")")])])]), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_48"
    }
  }), _c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0049-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Japanese SNLF during a break in the New Guinea jungle. More than 400 men from the 5th "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sasebo")]), _vm._v(" SNLF accompanied Colonel Yokoyama’s Advance Force from Simpson Harbour at Rabaul to Buna in high-speed freighters to establish a landing outpost and airbase. The SNLF and IJA forces retained their separate command structure. At Buna, the landings were completed by dawn on 21 July and the following day construction began on the base. Unit HQ, fortified bunkers and AA gun-pits were all constructed, while work on the existing airfield there (the Old Strip) commenced. Another Japanese base was built at Sanananda. A military hospital was also erected at Giruwa. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Author’s collection")]), _vm._v(")")])])]), _c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0049-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Japanese combat engineers repair a bridge across a stream on the Kokoda Trail. More than 2,000 engineers as well as Formosan and Korean labourers worked arduously to keep Japanese LOC open from the Buna and Gona bases to the front-line. The task was formidable as IJA planners calculated that the marching distance from Buna to Port Moresby was 360 kilometres. Thousands of porters would also be required since there was no vehicular road to assist in bringing supplies and ammunition to 5,000 troops along the front-line. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Author’s collection")]), _vm._v(")")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0049-03.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Elements of IJA Major-General Tomitaro Horii’s South Seas Detachment receive orders along the Kokoda Trail. The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nankai Shitai")]), _vm._v(" was initially composed of the 144th IR and various support units from the IJA 55th Division, including artillery, signals, transport, engineer and medical units. Prior combat experience included landings on Guam and the capture of Rabaul. On 1 July 1942, orders were given to Colonel Yosuke Yokoyama’s advance force comprising a battalion of the IJA 144th IR along with the 15th Independent Engineer Regiment, a mountain artillery company and other support units, to land on the northern Papuan beaches and to secure the Kokoda Airstrip and move as far south as the saddle of the Owen Stanley Range. Nine-hundred infantrymen of the 144th IR landed at Gona on 20–21 July from Rabaul. There was no sign of Australian troops at Gona. However, the Japanese convoy in the Gona anchorage was attacked by scores of Australian planes, including P-400 Airacobras, from Port Moresby. To the east, additional landings were made at Buna, which was to be transformed into a base and support centre for the Port Moresby over-land offensive starting 22 July. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Author’s collection")]), _vm._v(")")])])]), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_49"
    }
  }), _c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0050-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A Japanese 75mm Model 41 (1908) mountain gun is carried by artillerymen of the 55th Mountain Artillery Regiment. Although antiquated, the quick disassembly of this gun was ideal for the Papuan terrain across the Owen Stanley Range to support the infantry. In Papua during the summer of 1942, to maintain speed against the weakening Australian militia forces, this gun could be broken down into eleven components for packhorses or, as shown here, IJA artillerymen to carry. Typically, eighteen artillerymen could carry the component parts of the mountain gun. However, because of the Papuan terrain and climate, thirty-six men were required to manhandle the weapon. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Author’s collection")]), _vm._v(")")])])]), _c('a', {
    attrs: {
      "id": "page_50"
    }
  }), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_50"
    }
  }), _c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0051-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Australian militiamen surrender to elements of Horii’s South Seas Force along the Kokoda Trail soon after the Japanese commenced their summer over-land offensive across the Owen Stanley Range to capture Port Moresby. Many of the Australian militiamen were dispatched from Port Moresby as engineers and not as seasoned front-line combat troops. Veteran AIF troops from the mid-east were still in transit and had not yet arrived in Papua. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Author’s collection")]), _vm._v(")")])])]), _c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0051-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Australian militia and native carriers pass a dressing station at Eora Creek Village on their way out of a forward area along the Kokoda Trail for a well-earned rest, after having combated the Japanese advance from Buna over the Owen Stanley range in an attempt to seize Port Moresby from behind since the strategic defeat at the Battle of the Coral Sea precluded an amphibious landing there. ("), _c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NARA")])]), _vm._v(")")])])]), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_51"
    }
  }), _c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0052-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Tired and ragged Australian troops pass an abandoned Japanese bicycle in the thick mud of the Kokoda Trail during the summer of 1942. After advancing from Buna in July and August, the Japanese South Seas Detachment stopped their offensive at Ioribaiwa Ridge opposite Australian defensive positions on nearby Imita Ridge, 27 air miles from Port Moresby. ("), _c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AWM")])]), _vm._v(")")])])]), _c('a', {
    attrs: {
      "id": "page_52"
    }
  }), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_52"
    }
  }), _c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0053-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("An Australian patrol advances along a relatively flat and dry portion of the Kokoda Trail, with tall kunai grass on both sides, in an attempt to stop the southern advance of the Japanese towards Port Moresby. Note the soldier on the far left shouldering a Lewis Gun of First World War vintage. The Lewis Gun was of American design and was widely used by British and Commonwealth forces during both world wars and the Korean conflict. It was gas-operated and air-cooled, weighing only 26 pounds in contrast to the heavier Vickers MMG. It was easily identified by its distinctive circular magazine, which held ninety-seven 0.303-inch calibre rounds, its long cooling sleeve, and wide-mouth barrel. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Author’s collection")]), _vm._v(")")])])]), _c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0053-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Two Australian militiamen of the 39th Battalion move back from an aid station. These troops suffered grievously both at the hands of the more jungle-trained Japanese soldiers and the inhospitable elements of the Papuan terrain and climate. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Author’s collection")]), _vm._v(")")])])]), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_53"
    }
  }), _c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0054-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Gaunt-appearing Australian troops of the 2/27th Infantry Battalion take a respite along the Kokoda Trail at Itiki to have their rations in early October 1942. They had been out of touch with other troops for thirteen days and had very little food when they came in from the jungle. ("), _c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AWM")])]), _vm._v(")")])])]), _c('a', {
    attrs: {
      "id": "page_54"
    }
  }), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_54"
    }
  }), _c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0055-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The Australian Militia Imperial Force’s 39th Battalion stands at parade at Menari in late September 1942, after having engaged the Japanese on the Kokoda Trail throughout the summer months. This unit was wracked with disease and had incurred so many casualties that it almost ceased being active. Note the Australians holding their rifles in one hand and their ubiquitous walking sticks in the other for the Kokoda Trail’s rugged terrain. ("), _c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AWM")])]), _vm._v(")")])])]), _c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0055-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Australian Imperial Force veteran troops clean their SMLE rifles in their bivouac area, made from half-sheets, on a hillside along the Kokoda Trail. Although veterans of the Middle East and the Peloponnese, their jungle training was scant. ("), _c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NARA")])]), _vm._v(")")])])]), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_55"
    }
  }), _c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0056-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Australian troops with binoculars and a telescope gazing at the enemy positions at Ioribaiwa from the Imita Ridge after General Horii was ordered by IJA 17th Army HQ to cease the over-land advance and prepare to return to defensive fortifications back at Buna, Gona, Sanananda, and Giruwa. ("), _c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NARA")])]), _vm._v(")")])])]), _c('a', {
    attrs: {
      "id": "page_56"
    }
  }), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_56"
    }
  }), _c('a', {
    attrs: {
      "id": "page_57"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0057-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Australian soldiers using picks, shovels and a drill construct a road up a steep hill near Milne Bay ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("background")]), _vm._v("). Australian and US forces arrived at Milne Bay a month before the Japanese. Australian infantry with a strong RAAF air presence helped to overwhelm the enemy landing force for their first victory in Papua. ("), _c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NARA")])]), _vm._v(")")])])]), _c('a', {
    attrs: {
      "id": "page_57"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0057-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("An airstrip at Milne Bay. Locales such as these were prize targets for the Japanese in amphibious landings at the eastern tip of Papua in late August-early September 1943. However, tenacious defence by Major- General Cyril Clowes’ troops deprived the Japanese use of these airfields in a subsequent drive towards Port Moresby. Additionally, Australian control of the airstrips enabled Australian fighters to attack the Japanese both on the ground and over water to precipitate an enemy withdrawal. There were two infantry brigades at Milne Bay: the veteran AIF’s 18th Brigade under Brigadier Wooten and the militia’s 7th Brigade under Brigadier Field. These combined brigades constituted "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Milne Force")]), _vm._v(" under Clowes. ("), _c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AWM")])]), _vm._v(")")])])]), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_57"
    }
  }), _c('a', {
    attrs: {
      "id": "page_58"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0058-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Gaunt Australian troops fighting the Japanese at Milne Bay during the summer of 1942 march through deep mud, since the rain seldom stopped during August and September. The Australians were often afflicted with diseases and they suffered from malnutrition too. The climate was atrocious, being humid and hot all day, but frigid at night with almost continuous rain, making the track a treacherous mass of mobile mud with protruding vegetation roots. Among the insects were mosquitoes, mites, chiggers and leeches. Hookworm could be contracted by walking barefoot on the native tracks so troops were strongly encouraged to wear their shoes. Other diseases in this tropical hell included malaria, dengue fever, dysentery and jungle rot. ("), _c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AWM")])]), _vm._v(")")])])]), _c('a', {
    attrs: {
      "id": "page_58"
    }
  }), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_58"
    }
  }), _c('a', {
    attrs: {
      "id": "page_59"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0059-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("An Australian infantry section at Milne Bay marches in single-file past disabled Japanese light Type 95 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ha-Go")]), _vm._v(" tanks in September 1942. The Japanese light Type 95 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ha-Go")]), _vm._v(" tanks, which were essentially two-man MG platforms, were disabled during the abortive Milne Bay amphibious operation in late August 1942. Japanese planners erroneously assumed that they would face only two or three companies of Australians defending twenty or thirty aircraft. ("), _c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AWM")])]), _vm._v(")")])])]), _c('a', {
    attrs: {
      "id": "page_59"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0059-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("An Australian P-40 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kittyhawk")]), _vm._v(" in its revetment at one of the Milne Bay airfields. The RAAF had its 76 and 77 Fighter Squadrons comprising "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kittyhawks")]), _vm._v(" as well as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wirraways")]), _vm._v(" at Milne Bay to help repel the Japanese amphibious landings. The RAAF fighters attacked landing points, destroying enemy barges, fuel dumps and ammunition supplies. A Japanese merchant vessel, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nankai Maru")]), _vm._v(", was sunk with 300 troops on board. More inland, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kittyhawks")]), _vm._v(" provided close support for the Australian infantry by strafing and bombing Japanese positions. ("), _c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AWM")])]), _vm._v(")")])])]), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_59"
    }
  }), _c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0060-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A disabled Japanese landing barge, or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Daihatsu")]), _vm._v(", along with dead Japanese soldiers washed up on the beach at Milne Bay after the abortive attempt to seize it by the Japanese 2,000-man Hayashi Force (1st Landing Force) on 25 August 1942. More than half of the landing force was killed or wounded and, ten days after landing, the Japanese pulled out. The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Daihatsu")]), _vm._v(" was usually armed with two LMGs and could carry 100–120 men, an artillery piece, a light tank or truck. ("), _c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NARA")])]), _vm._v(")")])])]), _c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0060-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Due to a paucity of Allied shipping, two Australians have commandeered an intact captured Japanese landing barge, or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Daihatsu")]), _vm._v(", in Papua’s eastern coastal waters after the battle at Milne Bay was won. Two smaller sailing craft, which were also employed to ferry supplies, are seen ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("background")]), _vm._v("). ("), _c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NARA")])]), _vm._v(")")])])]), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_60"
    }
  }), _c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0061-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("An Australian soldier casually regards a monument to the officers and men who died defending Turnbull Field, the westernmost part of the Japanese advance at Milne Bay, in late August-early September 1942. Eighty-five unknown Japanese SNLF troops were interred there. General William Slim wrote of the Milne Bay defence that, ‘It was Australian soldiers who first broke the spell of the invincibility of the Japanese Army’. ("), _c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NARA")])]), _vm._v(")")])])]), _c('a', {
    attrs: {
      "id": "page_61"
    }
  }), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_61"
    }
  }), _c('a', {
    attrs: {
      "id": "page_62"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0062-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("An Australian soldier and native Papuan bearers trek up a rock-strewn waterway along the Kokoda Trail after the Japanese retreated towards their coastal bases at Buna, Gona, Sanananda and Giruwa. The Australian counter-attack, by General Vasey’s AIF 7th Division, commenced on 23 September. By 16 October, the Australian veterans had re-taken Templeton’s Crossing on the Owen Stanley Range south of Kokoda Village. ("), _c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NARA")])]), _vm._v(")")])])]), _c('a', {
    attrs: {
      "id": "page_62"
    }
  }), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_62"
    }
  }), _c('a', {
    attrs: {
      "id": "page_63"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0063-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Australians informally assembled for a flag-raising after re-taking Kokoda Village on 14 November 1942. Kokoda is situated in a valley 1,200 feet above sea level on the northern foothills of the Owen Stanley Range. In addition to serving as a Papuan administration post and a rubber plantation, Kokoda also had a small airfield, which was a main objective in the Japanese offensive from Buna and Gona. ("), _c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AWM")])]), _vm._v(")")])])]), _c('a', {
    attrs: {
      "id": "page_63"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0063-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Soldiers of the 127th IR of the US 32nd Division disembark their troop transport in Port Moresby on 17 September, as the Japanese advance on this town was halted by IJA HQ at Ioribaiwa Ridge 27 air miles away. The ‘green’ American National Guard troops are wearing tropical sun helmets and many were issued with the older Springfield 1903 bolt-action rifles. Port Moresby was to become MacArthur’s springboard for an Allied counter-offensive in Papua New Guinea. ("), _c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NARA")])]), _vm._v(")")])])]), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_63"
    }
  }), _c('a', {
    attrs: {
      "id": "page_64"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0064-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("An Australian with his rifle and bayonet shouldered observes two Americans salvaging scrap metal from downed Japanese planes at Port Moresby. In addition to troop landings, this town was the major supply depot for the advancing Allied movements onto the northern Papuan coastal Japanese outposts at Buna, Gona, Sanananda and Giruwa. ("), _c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NARA")])]), _vm._v(")")])])]), _c('a', {
    attrs: {
      "id": "page_64"
    }
  }), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_64"
    }
  }), _c('a', {
    attrs: {
      "id": "page_65"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0065-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A twin-engined "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("North American")]), _vm._v(" B-25 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mitchell")]), _vm._v(" medium bomber going through an overhaul at Port Moresby. The several airfields situated near Port Moresby provided USAAF Lieutenant-General George C. Kenney, commander of the Allied Air Forces and US Fifth Air Force in SWPA, numerous ‘dromes’ from which to mount offensive, interdicting missions against IJN reinforcement and supply operations as well as against IJA installations in northern Papua. ("), _c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NARA")])]), _vm._v(")")])])]), _c('a', {
    attrs: {
      "id": "page_65"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0065-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A twin-engined "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("North American")]), _vm._v(" B-25 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mitchell")]), _vm._v(" medium bomber attacks a Japanese freighter in a low-level strafing run, with its many nose-mounted MGs and cannon. The splash seen to the right is probably from a ‘skip-bombing’ attack on the same vessel. These aerial attack tactics were created by Kenney and his subordinates, such as Colonel Paul ‘Pappy’ Gunn, who modified the armament of both the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Douglas")]), _vm._v(" A-20 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Havoc")]), _vm._v(" light bombers and the B-25 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mitchell")]), _vm._v(" medium bomber. ("), _c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NARA")])]), _vm._v(")")])])]), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_65"
    }
  }), _c('a', {
    attrs: {
      "id": "page_66"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0066-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("An Allied C-47 transport plane with an American air-crew ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("upper right")]), _vm._v(") and Australian ground-crewmen at an airdrome, such as Schwimmer or Ward’s Drome, near Port Moresby. Battlefield casualties evacuated from northern Papuan airfields at Dobodura and Wanigela landed at Port Moresby, where more advanced medical attention could be provided compared to that at the Portable Hospital facilities just behind the combat lines. ("), _c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NARA")])]), _vm._v(")")])])]), _c('a', {
    attrs: {
      "id": "page_66"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51c67e53","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Chapter01.vue
// module id = 72
// module chunks = 0